import * as React from "react";
import { useCpFormValue } from "../../gvc/testNewForm/utils";
import { CpFormItem } from "../../gvc/testNewForm/CpFormItem";
import { CpLabel } from "../../gvc/testNewForm/CpLabel";
import { CpDescription } from "../../gvc/testNewForm/CpDescription";
import { CpErrorWarning } from "../../gvc/testNewForm/CpErrorWarning";
import { CpRadioGroup } from "../../gvc/testNewForm/CpRadioGroup";
import { CpInput } from "../../gvc/testNewForm/CpInput";
import { CpInputNumber } from "../../gvc/testNewForm/CpInputNumber";
import { CpKindSelect } from "../../gvc/testNewForm/temp/CpKindSelect";

interface Props {
  index: number;
}
export const Elastic: React.FC<Props> = ({ index }) => {
  const provider = useCpFormValue(`logging.${index}.elastic.provider`);

  return (
    <>
      <div style={{ maxWidth: 1000 }}>
        <CpFormItem>
          <CpLabel name={`logging.${index}.elastic.provider`}>Elastic Provider</CpLabel>
          <CpRadioGroup
            options={[
              { label: "AWS", value: "aws" },
              { label: "Elastic Cloud", value: "elasticCloud" },
              { label: "Generic", value: "generic" },
            ]}
            name={`logging.${index}.elastic.provider`}
            style={{ maxWidth: 600 }}
          />
          <CpErrorWarning name={`logging.${index}.elastic.provider`} />
        </CpFormItem>
        {provider === "aws" ? (
          <>
            <CpFormItem>
              <CpLabel name={`logging.${index}.elastic.aws.credentials`}>Credentials</CpLabel>
              <CpDescription>Select an AWS secret to access</CpDescription>
              <CpKindSelect
                kind="secret"
                queries={[{ property: "type", value: "aws" }]}
                name={`logging.${index}.elastic.aws.credentials`}
                optionValue="name"
                style={{ maxWidth: 600 }}
              />
              <CpErrorWarning name={`logging.${index}.elastic.aws.credentials`} />
            </CpFormItem>
            <CpFormItem>
              <CpLabel name={`logging.${index}.elastic.aws.host`}>Host</CpLabel>
              <CpInput name={`logging.${index}.elastic.aws.host`} style={{ maxWidth: 600 }} />
              <CpErrorWarning name={`logging.${index}.elastic.aws.host`} />
            </CpFormItem>
            <CpFormItem>
              <CpLabel name={`logging.${index}.elastic.aws.region`}>Region</CpLabel>
              <CpInput name={`logging.${index}.elastic.aws.region`} style={{ maxWidth: 600 }} />
              <CpErrorWarning name={`logging.${index}.elastic.aws.region`} />
            </CpFormItem>
            <CpFormItem>
              <CpLabel name={`logging.${index}.elastic.aws.port`}>Port</CpLabel>
              <CpInputNumber name={`logging.${index}.elastic.aws.port`} />
              <CpErrorWarning name={`logging.${index}.elastic.aws.port`} />
            </CpFormItem>
            <CpFormItem>
              <CpLabel name={`logging.${index}.elastic.aws.index`}>Index</CpLabel>
              <CpInput name={`logging.${index}.elastic.aws.index`} style={{ maxWidth: 600 }} />
              <CpErrorWarning name={`logging.${index}.elastic.aws.index`} />
            </CpFormItem>
            <CpFormItem>
              <CpLabel name={`logging.${index}.elastic.aws.type`}>Type</CpLabel>
              <CpInput name={`logging.${index}.elastic.aws.type`} style={{ maxWidth: 600 }} />
              <CpErrorWarning name={`logging.${index}.elastic.aws.type`} />
            </CpFormItem>
          </>
        ) : null}
        {provider === "elasticCloud" ? (
          <>
            <CpFormItem>
              <CpLabel name={`logging.${index}.elastic.elasticCloud.credentials`}>Credentials</CpLabel>
              <CpDescription>Select a Userpass secret to access</CpDescription>
              <CpKindSelect
                kind="secret"
                queries={[{ property: "type", value: "userpass" }]}
                name={`logging.${index}.elastic.elasticCloud.credentials`}
                optionValue="name"
                style={{ maxWidth: 600 }}
              />
              <CpErrorWarning name={`logging.${index}.elastic.elasticCloud.credentials`} />
            </CpFormItem>
            <CpFormItem>
              <CpLabel name={`logging.${index}.elastic.elasticCloud.cloudId`}>Cloud ID</CpLabel>
              <CpInput name={`logging.${index}.elastic.elasticCloud.cloudId`} style={{ maxWidth: 600 }} />
              <CpErrorWarning name={`logging.${index}.elastic.elasticCloud.cloudId`} />
            </CpFormItem>
            <CpFormItem>
              <CpLabel name={`logging.${index}.elastic.elasticCloud.index`}>Index</CpLabel>
              <CpInput name={`logging.${index}.elastic.elasticCloud.index`} style={{ maxWidth: 600 }} />
              <CpErrorWarning name={`logging.${index}.elastic.elasticCloud.index`} />
            </CpFormItem>
            <CpFormItem>
              <CpLabel name={`logging.${index}.elastic.elasticCloud.type`}>Type</CpLabel>
              <CpInput name={`logging.${index}.elastic.elasticCloud.type`} style={{ maxWidth: 600 }} />
              <CpErrorWarning name={`logging.${index}.elastic.elasticCloud.type`} />
            </CpFormItem>
          </>
        ) : null}
        {provider === "generic" ? (
          <>
            <CpFormItem>
              <CpLabel name={`logging.${index}.elastic.generic.credentials`}>Credentials</CpLabel>
              <CpDescription>Select a Userpass secret to access</CpDescription>
              <CpKindSelect
                kind="secret"
                queries={[{ property: "type", value: "userpass" }]}
                name={`logging.${index}.elastic.generic.credentials`}
                optionValue="name"
                style={{ maxWidth: 600 }}
              />
              <CpErrorWarning name={`logging.${index}.elastic.generic.credentials`} />
            </CpFormItem>
            <CpFormItem>
              <CpLabel name={`logging.${index}.elastic.generic.host`}>Host</CpLabel>
              <CpInput name={`logging.${index}.elastic.generic.host`} style={{ maxWidth: 600 }} />
              <CpErrorWarning name={`logging.${index}.elastic.generic.host`} />
            </CpFormItem>
            <CpFormItem>
              <CpLabel name={`logging.${index}.elastic.generic.path`}>Path</CpLabel>
              <CpInput name={`logging.${index}.elastic.generic.path`} style={{ maxWidth: 600 }} />
              <CpErrorWarning name={`logging.${index}.elastic.generic.path`} />
            </CpFormItem>
            <CpFormItem>
              <CpLabel name={`logging.${index}.elastic.generic.port`}>Port</CpLabel>
              <CpInputNumber name={`logging.${index}.elastic.generic.port`} />
              <CpErrorWarning name={`logging.${index}.elastic.generic.port`} />
            </CpFormItem>
            <CpFormItem>
              <CpLabel name={`logging.${index}.elastic.generic.index`}>Index</CpLabel>
              <CpInput name={`logging.${index}.elastic.generic.index`} style={{ maxWidth: 600 }} />
              <CpErrorWarning name={`logging.${index}.elastic.generic.index`} />
            </CpFormItem>
            <CpFormItem>
              <CpLabel name={`logging.${index}.elastic.generic.type`}>Type</CpLabel>
              <CpInput name={`logging.${index}.elastic.generic.type`} style={{ maxWidth: 600 }} />
              <CpErrorWarning name={`logging.${index}.elastic.generic.type`} />
            </CpFormItem>
          </>
        ) : null}
      </div>
    </>
  );
};
